// Facade for the jspdf-autotable prototype's live-grid integration (exporter-v2). Mirrors
// ../exporter/index.js's exportGrid orchestration almost exactly — same column-prep pipeline,
// reused directly rather than duplicated, since none of it is PDF-engine-specific. The ONLY
// thing that differs is which function renders a 'pdf' export; Excel (and any other format)
// falls straight through to the existing, untouched exportAsExcel.
import { validateBeforeExport } from '../exporter/validate.js';
import { cloneColumnsDeep } from '../exporter/cloneColumns.js';
import { flattenColumns } from '../exporter/flattenColumns.js';
import { syncVisibility } from '../exporter/syncVisibility.js';
import { processExportFields } from '../exporter/processExportFields.js';
import { exportAsExcel } from '../exporter/excelExporter.js';
import { formatCellValue } from '../exporter/cellFormatter.js';
import { exportAsPdfV2 } from './exportAsPdfV2.js';

export async function exportGridV2(e, fileName, originalColumns, options = {}) {
    if (!validateBeforeExport(e, options)) return;

    // e.component is the dxDataGrid instance
    const grid = e.component;

    const visibleFlat = flattenColumns(options.visibleColumns || grid.getVisibleColumns());

    let columnsForExport = cloneColumnsDeep(originalColumns);
    syncVisibility(columnsForExport, visibleFlat);

    const columnNames = [];
    columnsForExport = processExportFields(columnsForExport, columnNames, options.persistenceKey, options.storageGetter);

    const finalColumnsForExport = columnsForExport.filter((c) => c.caption || c.columns);

    try {
        if (e.format === 'pdf') {
            await exportAsPdfV2({ e, fileName, grid, finalColumnsForExport, options });
        } else {
            const flatFinalColumns = flattenColumns(finalColumnsForExport);
            const exportVisibilityMap = new Map(
                flatFinalColumns
                    .filter((col) => col.dataField)
                    .map((col) => [col.name, col.visible !== false])
            );
            await exportAsExcel({ e, fileName, grid, finalColumnsForExport, formatCellValue, options, exportVisibilityMap });
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error during export (v2):', err);
    }
}
